// @ts-check
import { defineConfig } from '../utils';

export function returnables() {
  return defineConfig({
    properties: {
      'Retornables.MostrarFirma': {
        defaultValue: true,
      },
    },
  });
}
